import { render } from "./NavBarComponent.vue?vue&type=template&id=51641803&scoped=true"
import script from "./NavBarComponent.vue?vue&type=script&lang=js"
export * from "./NavBarComponent.vue?vue&type=script&lang=js"

import "./NavBarComponent.vue?vue&type=style&index=0&id=51641803&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51641803"]])

export default __exports__